import type { RouteObject } from 'react-router-dom'
import { useRoutes } from 'react-router-dom'
import Layout from '@/components/Layout'
import Home from '@/pages/Home'
import Services from '@/pages/Services'
import Support from '@/pages/Support'
import About from '@/pages/About'
import Contact from '@/pages/Contact'
import Appointment from '@/pages/Appointment'
import Legal from '@/pages/Legal'
import Auth from '@/pages/Auth'
import ProtectedRoute from '@/components/ProtectedRoute'
import ClientDashboard from '@/pages/client/Dashboard'
import CreateTicket from '@/pages/client/CreateTicket'
import TicketDetail from '@/pages/client/TicketDetail'
import AdminDashboard from '@/pages/admin/Dashboard'
import AdminTickets from '@/pages/admin/AdminTickets'
import AdminTicketDetail from '@/pages/admin/AdminTicketDetail'
import AdminPages from '@/pages/admin/AdminPages'
import AdminAppointments from '@/pages/admin/AdminAppointments'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'services', element: <Services /> },
      { path: 'support', element: <Support /> },
      { path: 'a-propos', element: <About /> },
      { path: 'contact', element: <Contact /> },
      { path: 'rendez-vous', element: <Appointment /> },
      { path: 'mentions-legales', element: <Legal /> },
      { path: 'auth', element: <Auth /> },
      {
        path: 'espace-client',
        element: <ProtectedRoute><ClientDashboard /></ProtectedRoute>,
      },
      {
        path: 'espace-client/nouveau-ticket',
        element: <ProtectedRoute><CreateTicket /></ProtectedRoute>,
      },
      {
        path: 'espace-client/ticket/:id',
        element: <ProtectedRoute><TicketDetail /></ProtectedRoute>,
      },
      {
        path: 'admin',
        element: <ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>,
      },
      {
        path: 'admin/tickets',
        element: <ProtectedRoute adminOnly><AdminTickets /></ProtectedRoute>,
      },
      {
        path: 'admin/tickets/:id',
        element: <ProtectedRoute adminOnly><AdminTicketDetail /></ProtectedRoute>,
      },
      {
        path: 'admin/pages',
        element: <ProtectedRoute adminOnly><AdminPages /></ProtectedRoute>,
      },
      {
        path: 'admin/rendez-vous',
        element: <ProtectedRoute adminOnly><AdminAppointments /></ProtectedRoute>,
      },
    ],
  },
]

function App() {
  return useRoutes(routes)
}

export default App
